import { render, staticRenderFns } from "./CRInput.vue?vue&type=template&id=dc40a0fa&scoped=true"
import script from "./CRInput.vue?vue&type=script&lang=js"
export * from "./CRInput.vue?vue&type=script&lang=js"
import style0 from "./CRInput.vue?vue&type=style&index=0&id=dc40a0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc40a0fa",
  null
  
)

export default component.exports